export const ONE_MINUTE = 60 * 1000;
export const ITEM_WIDTH = 120;
// export const VIEWPORT_WIDTH = 600;
export const REPEAT_COUNT_SPIN = 2;
export const REPEAT_COUNT_RENDER = 6;
export const TOTAL_HEIGHT = 500;
export const BASE_WIDTH = 550;
export const TIP_WIDTH = 10;

// useLogin timeout and retries count
export const SIGN_TIMEOUT = 10000;
export const MAX_RETRIES = 3;
export const CHAIN_ID_HEX = "0x1";
